export function initPlyr(selector = '.video-player__video, .video-player video') {
  const videos = document.querySelectorAll<HTMLElement>(selector);
  if (videos) {
    void import('plyr').then(({ default: Plyr }) => {
      videos.forEach((video) => {
        new Plyr(video);
      });
    });
  }
}
